exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "a{color:#52ae30;font-weight:600;transition:.2s}a:hover{color:#390}a:active{color:#5ec738}a:focus{outline-offset:3px;outline:2px solid #6fb4d8}", ""]);

